export const returnFirstElFromArray = arr => arr[0];
